import Box from '@zenbusiness/zui/Box';
import List from '@zenbusiness/zui/List';
import ListItem from '@zenbusiness/zui/ListItem';
import { styled } from '@zenbusiness/zui/styles';
import Tab from '@zenbusiness/zui/Tab';
import TabList from '@zenbusiness/zui/TabList';

export const BenefitList = styled(List)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: '1fr',
  gap: theme.spacing(4),
  padding: theme.spacing(2),
  backgroundColor: theme.palette.fixed.white,
  borderRadius: theme.shape.rounded.xl,

  [theme.breakpoints.up('lg')]: {
    gridTemplateColumns: 'repeat(3, 1fr)',
    padding: theme.spacing(3)
  }
}));

export const BenefitItem = styled(ListItem)(({ theme }) => ({
  alignItems: 'flex-start',
  padding: theme.spacing(0)
}));

export const Icon = styled(Box)(({ theme }) => ({
  width: '2rem',
  height: '2rem',
  padding: theme.spacing(1),
  backgroundColor: theme.palette.background.green.light,
  borderRadius: theme.shape.rounded.md,

  [theme.breakpoints.up('md')]: {
    width: '2.5rem',
    height: '2.5rem'
  }
}));

export const BenefitsTabList = styled(TabList)(({ theme }) => ({
  '.MuiTabs-indicator': {
    display: 'none'
  },

  '.MuiTabs-flexContainer': {
    backgroundColor: theme.palette.background.grey.dark,
    borderRadius: theme.shape.rounded.lg,
    justifyContent: 'space-around',
    gap: 0
  }
}));

export const BenefitsTab = styled(Tab)(({ theme }) => ({
  '&.MuiTab-root': {
    maxWidth: 'unset',
    paddingBlock: theme.spacing(2),
    flex: 1,

    '&.Mui-selected': {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.main,
      borderRadius: theme.shape.rounded.lg
    }
  }
}));
